import React, {FunctionComponent} from "react";
import {makeStyles} from "tss-react/mui";
import {Container} from "@mui/material";
import WebsiteLoginForm from "@/Domains/AuthenticationManagement/WebsiteLoginForm";
import {Redirect} from "react-router-dom";
import {useSelector} from "react-redux";
import {selectIsLoggedIn, ViewerState} from "@/Redux/Auth/AuthReducer";

interface LoginMainProps {
}

const useStyles = makeStyles()((theme) => ({
    container: {
        width: "100%",
        maxWidth: "100%",
        padding: "6px",
        minHeight: "100vh",
    },
}));

const WebsiteMainLoginView: FunctionComponent<
    LoginMainProps
> = (): JSX.Element => {
    const {classes} = useStyles();

    const isLoggedIn = useSelector((state) =>
        selectIsLoggedIn(state as ViewerState),
    );

    if (isLoggedIn) {
        return <Redirect to="/manager"/>;
    }

    return (
        <Container fixed className={classes.container}>
            <WebsiteLoginForm/>
        </Container>
    );
};

export default WebsiteMainLoginView;
